import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  MenuItem,
  Box,
  IconButton,
  InputAdornment,
} from "@mui/material";
import axios from "axios";
import axiosInstance from "../axiosConfig/instance";
import Swal from "sweetalert2";
import { create } from "../components/Apis";
import Otpverify from "./otpverify";
import i18n from "../i18n";
import { useDropdownStyle } from "../hooks/useDropdownStyle";
import { useTranslation } from "react-i18next";
import styles from "../style/createStyle.module.css"
import EmailIcon from '@mui/icons-material/Email';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router";



const Create = () => {
  const [cities, setCities] = useState([]);
  console.log("cities", cities)
  const [countries, setCountries] = useState([]);
  const [identityTypes, setIdentityTypes] = useState([]);
  // const [otp, setotp] = useState("");
  // const [verifyform, setverifyform] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // حالة لمعرفة الصورة المرفوعة
  const { t } = useTranslation();
  const navigate = useNavigate();

  console.log(identityTypes)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    address: "",
    cityId: "5",
    countryId: "",
    identityTypeId: "",

  });

  const [Files, setFiles] = useState({

    identityImages: [],
    profileImage: null,
  });

  console.log(Files)
  useEffect(() => {
    const fetchDropdownData = async () => {
      // try {
      //   // استدعاء APIs بشكل متزامن
      //   const [citiesRes, countriesRes, identityTypesRes] = await Promise.all([
      //     axiosInstance.get("/v1/cities"), // استبدل بـ URL الصحيح
      //     axiosInstance.get("/v1/countries"), // استبدل بـ URL الصحيح
      //     axiosInstance.get("/v1/identity-types"), // استبدل بـ URL الصحيح
      //   ]);

      //   console.log("citiesRes", citiesRes.data.data)
      //   // تعيين البيانات في الحالات
      //   setCities(citiesRes.data.data);
      //   setCountries(countriesRes.data.data);
      //   setIdentityTypes(identityTypesRes.data.data);
      // } catch (error) {
      //   console.error("Error fetching dropdown data:", error);
      // }

      try {
        // First, let's test each endpoint separately
        console.log('Starting API calls...');

        try {
          const citiesRes = await axiosInstance.get("/v1/cities");
          console.log('Cities data:', citiesRes.data);
          if (citiesRes.data?.data) setCities(citiesRes.data.data);
        } catch (error) {
          console.error("Cities API error:", error.response || error);
        }

        try {
          const countriesRes = await axiosInstance.get("/v1/countries");
          console.log('Countries data:', countriesRes.data);
          if (countriesRes.data?.data) setCountries(countriesRes.data.data);
        } catch (error) {
          console.error("Countries API error:", error.response || error);
        }

        try {
          const identityTypesRes = await axiosInstance.get("/v1/identity-types");
          console.log('Identity Types data:', identityTypesRes.data);
          if (identityTypesRes.data?.data) setIdentityTypes(identityTypesRes.data.data);
        } catch (error) {
          console.error("Identity Types API error:", error.response || error);
        }

      } catch (error) {
        console.error("General error:", {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
          fullError: error
        });

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `Failed to load data: ${error.response?.data?.message || error.message}`,
        });
      }
    };

    fetchDropdownData();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "identityImages") {
      if (files.length === 0) {
        setFiles((prevData) => ({
          ...prevData,
          [name]: null, // Set to null when no files are selected
        }));
      } else {
        setFiles((prevData) => ({
          ...prevData,
          [name]: [...Array.from(files)], // Add new files
        }));
      }
    } else if (name === "profileImage") {
      const file = files[0];
      setFiles((prevData) => ({
        ...prevData,
        [name]: file,
      }));
      // عرض معاينة الصورة
      const reader = new FileReader();
      reader.onload = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(); // التصحيح: استخدام اسم متغير صحيح بدلاً من إعادة تعريفه

    // إضافة كل قيمة إلى FormData بشكل منفصل
    data.append("first_name", formData.firstName);
    data.append("last_name", formData.lastName);
    data.append("email", formData.email);
    data.append("phone_number", formData.phoneNumber);
    data.append("password", formData.password);
    data.append("address", formData.address);
    data.append("city_id", formData.cityId);
    data.append("country_id", formData.countryId);
    // data.append("identity_type_id", formData.identityTypeId);

    // Only append identity images if they exist
    // if (Files.identityImages) {
    //   Files.identityImages.forEach((img) => {
    //     data.append("identity_images[]", img);
    //   });
    // }

    // إضافة صورة الملف الشخصي إذا كانت موجودة
    if (Files.profileImage) {
      data.append("image", Files.profileImage); // التصحيح: استخدام formData.profileImage بدلاً من Files.profileImage
    }

    // عرض محتويات FormData في الكونسول
    for (let [key, value] of data.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      Swal.showLoading();
      // إرسال البي
      // swانات إلى الـ API
      const res = await create(data); // التصحيح: تأكد من وجود دالة create
      Swal.close();

      // console.log("The Otp of register",res?.data?.data?.otp);
      console.log(res);
      // التحقق من الاستجابة
      if (res?.data?.success) {
        console.log(res?.data)
        Swal.fire("Account created successfully")
        navigate('/')
        // تنفيذ أي إجراء عند النجاح
        // console.log("oooooooooooottttttppppp", res?.data?.data?.otp);
        localStorage.setItem('regtoken', res?.data?.data?.token)
        // setotp(res?.data?.data?.otp);
        // setverifyform(true)

        //  const ress = await create(res.data.data.otp); // التصحيح: تأكد من وجود دالة create
        //  console.log(ress)

      } else if (res.message === "Request failed with status code 413") {
        console.error("Please upload a smaller image or PDF file.");
      } else if (res.response?.data?.success === false) {
        Swal.fire({
          icon: "error", // لتحديد رمز الخطأ
          title: "Error",
          text: res?.response?.data?.message || "An error occurred.",
          confirmButtonText: "OK",
        });

      } else {
        Swal.fire({
          icon: "error", // لتحديد رمز الخطأ
          title: "Error",
          text: res.response.data.message || "An error occurred.",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error", // لتحديد رمز الخطأ
        title: "Error",
        text: error?.message || "An error occurred.",
        confirmButtonText: "OK",
      });
    }
    finally {

    }
  };

  const { DropStyle, inputStyle, iputType } = useDropdownStyle();


  return (
    <Box sx={{ width: "100%", height: "100vh", textAlign: 'center', overflow: "hidden", p: 4, mx: "auto", position: "relative", backgroundColor: "FFF9F3" }} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
        <div className={styles.contentWrapper}>
          <div className={styles.logoBackground}>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/8d9611c3cf05953aababec0f35a2e61ce7f9fbef"
              alt="Bask Hospitality Logo"
              className={styles.logoImage}
            />
          </div>
          <section className={styles.formContainer} style={{paddingTop:"60px"}}>
            <p className={styles.welcomeHeading}>Create Your Account </p>
            <form onSubmit={handleSubmit} dir='ltr' style={{ 
              width: '100%',
              maxWidth: '500px',
              margin: '0 auto',
              padding: '0 16px'
            }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <IconButton
                      component="label"
                      sx={{
                        width: 70,
                        height: 70,
                        borderRadius: "50%",
                        backgroundColor: "#f0f0f0",
                        border: "2px dashed #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "&:hover": {
                          backgroundColor: "#e0e0e0",
                        },
                      }}
                    >
                      {previewImage ? (
                        <Box
                          component="img"
                          src={previewImage}
                          alt="Profile Preview"
                          sx={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <Typography variant="h6" color="text.secondary">
                          profile
                        </Typography>
                      )}
                      <input
                        type="file"
                        name="profileImage"
                        hidden
                        onChange={handleFileChange}
                      />
                    </IconButton>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label={t('firstName')}
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    inputProps={iputType}
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="start">
                    //       <EmailIcon />
                    //     </InputAdornment>
                    //   ),
                    //   sx: {
                    //     fontSize: "12px",
                    //     top: "-6px", 
                    //   },
                    // }}
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": { padding: "8px" }, // تقليل التباعد الداخلي
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عندما يكون الإدخال نشطًا، ينخفض اللابل قليلًا داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل للأحمر عند التركيز

                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={t('lastName')}
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    inputProps={iputType}
                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="start">
                    //       <EmailIcon />
                    //     </InputAdornment>
                    //   ),
                    //   sx: {
                    //     fontSize: "12px", // تصغير خط اللابل
                    //     top: "-6px", // ضبط تمركز اللابل
                    //   },
                    // }}
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": { padding: "8px" }, // تقليل التباعد الداخلي
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عندما يكون الإدخال نشطًا، ينخفض اللابل قليلًا داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل للأحمر عند التركيز

                        },
                      },
                    }}

                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={t('email')}
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    type="email"
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": { padding: "8px" }, // تقليل التباعد الداخلي
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عندما يكون الإدخال نشطًا، ينخفض اللابل قليلًا داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل للأحمر عند التركيز

                        },
                      },
                    }}
                  />


                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={t('phoneNumber')}
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    type="tel"
                    inputProps={{
                      ...iputType,
                      inputMode: 'tel',
                      pattern: '[0-9]*'
                    }}
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": { padding: "8px" }, // تقليل التباعد الداخلي
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عندما يكون الإدخال نشطًا، ينخفض اللابل قليلًا داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل للأحمر عند التركيز

                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={t('password')}
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    type="password"
                    inputProps={iputType}
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": { padding: "8px" }, // تقليل التباعد الداخلي
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عندما يكون الإدخال نشطًا، ينخفض اللابل قليلًا داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل للأحمر عند التركيز

                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={t('address')}
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    inputProps={iputType}
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": { padding: "8px" }, // تقليل التباعد الداخلي
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عندما يكون الإدخال نشطًا، ينخفض اللابل قليلًا داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل للأحمر عند التركيز

                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label={t('country')}
                    name="countryId"
                    value={formData.countryId}
                    onChange={handleInputChange}
                    fullWidth
                    select
                    required
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": {
                        padding: "8px",
                        textAlign: "left", // **ضبط الاتجاه لليسار**
                        direction: "ltr",  // **تحديد اتجاه النص**
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                      "& .MuiSelect-select": {
                        textAlign: "left", // **يضمن أن النص المختار يكون باتجاه اليسار**
                        direction: "ltr", // **يضمن أن اتجاه النص المختار LTR**
                        paddingLeft: "10px", // **مسافة صغيرة من اليسار لراحة النظر**
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        direction: "ltr",
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عند التركيز، يبقى داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل عند التركيز
                        },
                      },
                    }}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.id} value={country.id} sx={{ textAlign: "left", direction: "ltr" }}>
                        {country.name} {/* جعل النص داخل القائمة أيضًا `ltr` */}
                      </MenuItem>
                    ))}
                  </TextField>

                </Grid>
                {/* <Grid item xs={12}>
                  <TextField
                    label={t('city')}
                    name="cityId"
                    value={formData.cityId}
                    onChange={handleInputChange}
                    fullWidth
                    select
                    required
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" }, // تقليل ارتفاع الإدخال
                      "& .MuiInputBase-input": {
                        padding: "8px",
                        textAlign: "left", // **ضبط الاتجاه لليسار**
                        direction: "ltr",  // **تحديد اتجاه النص**
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, // لون الإطار العادي
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, // عند تحريك الماوس فوق الحقل
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, // عند التركيز يصبح أحمر غامق
                      },
                      "& .MuiSelect-select": {
                        textAlign: "left", // **يضمن أن النص المختار يكون باتجاه اليسار**
                        direction: "ltr", // **يضمن أن اتجاه النص المختار LTR**
                        paddingLeft: "10px", // **مسافة صغيرة من اليسار لراحة النظر**
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        direction: "ltr",
                        fontSize: "12px", // تصغير خط اللابل
                        top: "50%",
                        left: "15px", // وضع اللابل في المنتصف
                        transform: "translateY(-50%)", // تثبيت اللابل عند المنتصف دائمًا
                        transition: "all 0.3s ease-in-out", // تأثير انسيابي للحركة
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", // عند التركيز، يبقى داخل الإطار
                          transform: "translateY(0)",
                          color: "#20130D !important", // تغيير لون اللابل عند التركيز
                        },
                      },
                    }}
                  >
                    {cities.map((city) => (
                      <MenuItem key={city.id} value={city.id} sx={{ textAlign: "left", direction: "ltr" }}>
                        {city.city}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}
               
               
                {/* <Grid item xs={12}>
                  <TextField
                    label={t('identityType')}
                    name="identityTypeId"
                    value={formData.identityTypeId}
                    onChange={handleInputChange}
                    fullWidth
                    select
                    required
                    sx={{
                      "& .MuiInputBase-root": { height: "36px" },
                      "& .MuiInputBase-input": {
                        padding: "8px",
                        textAlign: "left", 
                        direction: "ltr",  
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "gray" }, 
                        "&:hover fieldset": { borderColor: "var(--pri-col)" }, 
                        "&.Mui-focused fieldset": { borderColor: "var(--pri-col)", borderWidth: "2px" }, 
                      },
                      "& .MuiSelect-select": {
                        textAlign: "left", 
                        direction: "ltr", 
                        paddingLeft: "10px", 
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        direction: "ltr",
                        fontSize: "12px", 
                        top: "50%",
                        left: "15px", 
                        transform: "translateY(-50%)", 
                        transition: "all 0.3s ease-in-out", 
                        "&.MuiInputLabel-shrink": {
                          top: "-6px", 
                          transform: "translateY(0)",
                          color: "#20130D !important", 
                        },
                      },
                    }}
                  >
                    {identityTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id} sx={{ textAlign: "left", direction: "ltr" }}>
                        {type.identity_type} 
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}

                {/* <Grid item xs={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <input
                      type="file"
                      name="identityImages"
                      multiple
                      onChange={handleFileChange}
                      style={{
                        display: "none",
                      }}
                      id="upload-input"
                    />
                    <label htmlFor="upload-input">
                      <Button variant="contained" sx={{
                        borderRadius: "5px",
                        backgroundColor: "#C47D60",
                        "&:hover": {
                          backgroundColor: "#a86850", // لون أغمق قليلاً عند التمرير
                        },
                      }} component="span">
                        {t('uploadIdentityImages')}
                      </Button>
                    </label>
                    <Typography variant="body2" color="text.secondary"
                      dir={"rtl"}
                    >
                      {Files.identityImages?.length || 0} : {t('imagesSelected')}
                    </Typography>
                  </Box>
                </Grid> */}


                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%", // لضمان محاذاة وسطية
                    }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        borderRadius: "5px",
                        backgroundColor: "var(--pri-col)",
                        width: "100%",
                        "&:hover": {
                          backgroundColor: "var(--pri-col)", // لون أغمق قليلاً عند التمرير
                        },
                      }}
                    >
                    Sign Up                    
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </section>
        </div>
       

      {/* handle in responsive in app css */}
      <img src="../../assets/Bask 01-04 1.png"
      className="leftImage"
        style={{ width: "229px", height: "242px", position: "absolute", top: "0px", left: "0px", transform: "rotate(180deg)" }} />
      <img src="../../assets/image 4.png"
      className="rightImage"
        style={{ width: "304.241px", height: "427.118px", position: "absolute", top: "2rem", right: "5rem" }} />

    </Box>
  );
};

export default Create;
